import type { CmsContentAboutServicesForm } from "@/modules/cms/domain/contracts";
import type { StockPublicServiceDTO } from "@/modules/stock-public/presentation/api/client";
import {
  stockImageKeyFromService,
} from "@/shared/lib/stock-public-image-key";
import { slugify } from "@/shared/lib/slugify";
import type { UseFormSetValue } from "react-hook-form";

function pickBodyText(dto: StockPublicServiceDTO): string {
  const desc = dto.description?.trim();
  const summary = dto.specification?.summary?.trim();
  return desc || summary || "";
}

function pickIntroText(dto: StockPublicServiceDTO): string {
  const summary = dto.specification?.summary?.trim();
  const desc = dto.description?.trim();
  return summary || desc || "";
}

function pickSlug(dto: StockPublicServiceDTO): string {
  const fromName = slugify(dto.nameEn?.trim() || dto.name.trim());
  if (fromName) return fromName;
  return slugify(dto.code.replace(/^SRV-/i, "service-"));
}

/** เติม field CMS จาก Stock service — เรียกหลังเลือกใน picker */
export function applyStockServiceAutofill(
  setValue: UseFormSetValue<CmsContentAboutServicesForm>,
  serviceIndex: number,
  dto: StockPublicServiceDTO,
): void {
  const base = `items.${serviceIndex}` as const;
  const body = pickBodyText(dto);
  const intro = pickIntroText(dto);
  const nameEn = dto.nameEn?.trim() ?? "";

  setValue(`${base}.stockServiceCode`, dto.code, { shouldDirty: true });
  setValue(`${base}.showStockPrice`, true, { shouldDirty: true });
  setValue(`${base}.slug`, pickSlug(dto), { shouldDirty: true });
  setValue(`${base}.title.lo`, dto.name, { shouldDirty: true });
  setValue(`${base}.title.en`, nameEn, { shouldDirty: true });
  setValue(`${base}.content.lo`, body, { shouldDirty: true });
  setValue(`${base}.content.en`, nameEn ? body : "", { shouldDirty: true });
  setValue(`${base}.intro.lo`, intro, { shouldDirty: true });
  setValue(`${base}.intro.en`, nameEn ? intro : "", { shouldDirty: true });
  setValue(`${base}.isActive`, dto.isActive, { shouldDirty: true });
  setValue(`${base}.linkMode`, "none", { shouldDirty: true });
  setValue(`${base}.showcaseKind`, undefined, { shouldDirty: true });

  const stockImageKey = stockImageKeyFromService(dto);
  if (stockImageKey) {
    setValue(`${base}.imageKey`, stockImageKey, { shouldDirty: true });
  }
}
